// @flow

import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import ListPage from 'esm-web-pro/containers/pages/ListPage';
import { BooleanColumn } from 'speed-js-react-web';
import { bindActionCreators } from 'redux';
import { addBreadcrumbs, removeBreadcrumb } from 'esm-web-pro/redux/breadcrumb';
import { connect, useDispatch } from 'react-redux';
import withRouter from 'speed-js-react/src/router/withRouter';
import { APIContext } from 'speed-js-react';
import { Route, Switch } from 'react-router-dom';
import { More } from 'grommet-icons';
import QuickViewIcon from 'esm-web-pro/components/icons/QuickViewIcon';
import ActionsColumn from 'speed-js-react-web/src/components/grommet2/tables/columns/Action/ActionsColumn';
import TaskTypeEscalationMatricesDashboard
    from 'esm-web-pro/components/pages/nomenclatures/sidepanel/EscalationMatricesTaskTypeDashboard';
import TaskTypeSidePanel from
    'esm-web-pro/components/pages/nomenclatures/sidepanel/EscalationMatricesTaskTypeSidePanel';


type Props = {
    match: Object,
    addBreadcrumbs: (title: string, link: string) => void,
    removeBreadcrumb: (title: string) => void,
};

const NOMENCLATURE_SIDEPANEL_KEY = 'NOMENCLATURE_TYPE_ID';

const messages = defineMessages({
    escalationMatrices: {
        id: 'adminpage-nomenclature-escalation-matrices-label',
        defaultMessage: 'Escalation Matrices',
    },
});

const EscalationMatricesTaskTypes = (props: Props) => {
    const listRef = React.useRef(null);
    const { formatMessage } = useIntl();
    const reloadData = () => {
        if (listRef.current && listRef.current.table.current) {
            listRef.current.table.current.reloadData();
        }
    };
    const {
        addBreadcrumbs: addBreadcrumbsAction,
        removeBreadcrumb: removeBreadcrumbAction,
    } = props;

    const [taskTypes, setTaskTypes] = React.useState(null);

    const { apiClient } = React.useContext(APIContext);
    const dispatch = useDispatch();

    const reloadNomenclatureType = React.useCallback(() => {
        apiClient.resources.nomenclatureTaskType.list().then((response) => {
            setTaskTypes(response);
        });
    }, [apiClient]);

    React.useEffect(() => {
        reloadNomenclatureType();
    }, [reloadNomenclatureType]);

    React.useEffect(() => {
        if (taskTypes) {
            dispatch(addBreadcrumbsAction([
                {
                    title: formatMessage(messages.escalationMatrices),
                    link: '/administration/nomenclatures/escalation-matrices/',
                },
            ]));
        }
        return () => {
            if (taskTypes) {
                dispatch(removeBreadcrumbAction(formatMessage(messages.escalationMatrices)));
            }
        };
    }, [addBreadcrumbsAction, removeBreadcrumbAction, dispatch, taskTypes, formatMessage]);

    return taskTypes && (
        <Switch>
            <Route
                path="/administration/nomenclatures/escalation-matrices/:id/dashboard"
                component={TaskTypeEscalationMatricesDashboard}
            />
            <Route
                path="/administration/nomenclatures/escalation-matrices"
                render={() => (
                    <ListPage
                        ref={listRef}
                        {...props}
                        resourceName="nomenclatureTaskType"
                        permissions={['nomenclatures.view_nomenclatureitem']}
                        columns={[
                            {
                                Header: <FormattedMessage id="name" defaultMessage="Name" />,
                                accessor: 'translations.bg.name',
                                orderBy: 'name',
                                minWidth: 120,
                            },
                            {
                                Header: <FormattedMessage id="nomenclatureitem-code" defaultMessage="Code" />,
                                accessor: 'code',
                                minWidth: 120,
                            },
                            {
                                Header: <FormattedMessage id="nomenclatureitem-is-active" defaultMessage="Is active" />,
                                accessor: 'is_active',
                                minWidth: 70,
                                Cell: BooleanColumn,
                            },
                            {
                                actions: [{
                                    label: <FormattedMessage id="dashboard-action" defaultMessage="Dashboard" />,
                                    to: '/administration/nomenclatures/escalation-matrices/{id}/dashboard',
                                    type: 'link',
                                    icon: <More />,
                                }, {
                                    label: <FormattedMessage
                                        id="projmanag-counterparties-quickview"
                                        defaultMessage="Quick View"
                                    />,
                                    type: 'quickView',
                                    accessor: 'id',
                                    component: TaskTypeSidePanel,
                                    resourceName: 'nomenclatureTaskType',
                                    icon: <QuickViewIcon />,
                                    getTitle: (obj) => obj.translations.bg.name,
                                    panelId: NOMENCLATURE_SIDEPANEL_KEY,
                                    reload: reloadData,
                                }],
                                Cell: ActionsColumn,
                                minWidth: 70,
                            },
                        ]}
                    />
                )}
            />
        </Switch>
    );
};


const mapDispatchToProps = ((dispatch) => (bindActionCreators({ addBreadcrumbs, removeBreadcrumb }, dispatch)));

export default withRouter(connect(null, mapDispatchToProps)(EscalationMatricesTaskTypes));
